import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  gap: 40px;
  margin-bottom: 16px;
`;

export const InlineRow = (props) => {
  return <Container>{props.children}</Container>;
};
